export default [{
  path: 'moneyrecord/:leftid/:parent_id',
  name: 'backend_moneyrecord',
  component: () => import('@/views/backend/admin/money/record/list'),
  meta: {
    tpflag: 'backend',
    title: '资金记录',
  }
}, {
  path: 'moneybank/:leftid/:parent_id',
  name: 'backend_moneybank',
  component: () => import('@/views/backend/admin/money/bank/list'),
  meta: {
    tpflag: 'backend',
    title: '资金账户',
  }
}, {
  path: 'withdrawal/:leftid/:parent_id',
  name: 'backend_withdrawal',
  component: () => import('@/views/backend/admin/money/withdrawal/list'),
  meta: {
    tpflag: 'backend',
    title: '提现管理',
  }
}, {
  path: 'invoice/:leftid/:parent_id',
  name: 'backend_invoice',
  component: () => import('@/views/backend/admin/money/invoice/list'),
  meta: {
    tpflag: 'backend',
    title: '开票管理',
  }
}]



// WEBPACK FOOTER //
// ./src/router/kdsuper/_money.js